import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Xarrow from 'react-xarrows';

import {
    changeTotalScore,
    setCurrentAnswerStatus,
} from '../../store/sessionStatus';

import Button from '../../components/button/Button';
import FieldType1 from './FieldType1';

import './type1.css';

export default function Type1({ question, answer }) {
    const dispatch = useDispatch();
    const answers = question.answers;
    const [arrows, changeArrows] = useState([]);
    const [activeQuestion, setActiveQuestion] = useState(0);
    const [activeAnswer, setActiveAnswer] = useState(0);
    const [disabledButton, setDisabledButton] = useState(false);

    const answersFields = useRef();
    const questionsFields = useRef();

    useEffect(() => {
        if (activeQuestion && activeAnswer) {
            const newArrowsState = arrows
                .filter(
                    (arrow) =>
                        arrow.start !== activeQuestion &&
                        arrow.end !== activeAnswer,
                )
                .concat([
                    {
                        start: activeQuestion,
                        end: activeAnswer,
                        color: '#7B61FF',
                    },
                ]);
            changeArrows(newArrowsState);

            setActiveAnswer(0);
            setActiveQuestion(0);

            setTimeout(() => {
                questionsFields.current.childNodes.forEach(
                    (question) => (question.style.borderColor = '#6f47ff00'),
                );
                answersFields.current.childNodes.forEach(
                    (answer) => (answer.style.borderColor = '#6f47ff00'),
                );
            }, 250);
        }
    }, [arrows, activeQuestion, activeAnswer]);

    const activateField = (e, type) => {
        type.current.childNodes.forEach(
            (child) => (child.style.borderColor = '#6f47ff00'),
        );
        e.target.parentNode.style.borderColor = '#6e47ff';
    };

    const checkAnswer = () => {
        changeArrows((prevState) =>
            prevState.map((arrow) => {
                if (arrow.start === arrow.end) {
                    return {
                        ...arrow,
                        color: '#48CFAD',
                    };
                } else
                    return {
                        ...arrow,
                        color: '#EC107C',
                    };
            }),
        );
        const status =
            arrows.length > 0 && arrows.length === answers.length
                ? !arrows.some((arrow) => arrow.start !== arrow.end)
                : false;

        dispatch(setCurrentAnswerStatus(status));

        if (status) {
            dispatch(changeTotalScore(question.points));
        }
        setTimeout(() => answer(), 1500);
        setDisabledButton(true);
    };

    return (
        <div className="questionWrapper">
            <div className="type1-textArea">{question.text}</div>
            <div className="type1-questionArea">
                <div ref={questionsFields} className="type1-questions">
                    {answers.map((question, i) => (
                        <FieldType1
                            key={i}
                            type={'question'}
                            info={question.start}
                            onClick={(e) => {
                                if (!disabledButton) {
                                    activateField(e, questionsFields);
                                    setActiveQuestion(question.start.id);
                                }
                            }}
                        />
                    ))}
                </div>
                <div ref={answersFields} className="type1-answers">
                    {answers.map((answer, i) => (
                        <FieldType1
                            key={i}
                            type={'answer'}
                            info={answer.end}
                            onClick={(e) => {
                                if (!disabledButton) {
                                    activateField(e, answersFields);
                                    setActiveAnswer(answer.end.id);
                                }
                            }}
                        />
                    ))}
                </div>
                <div className="type1-arrows">
                    {arrows.map((arrow, i) => {
                        return (
                            <Xarrow
                                key={i}
                                curveness={0.6}
                                animateDrawing={1.5}
                                arrowHeadProps={{
                                    fill: arrow.color,
                                    strokeWidth: '0.2',
                                    stroke: arrow.color,
                                }}
                                tailShape="circle"
                                showTail={true}
                                arrowTailProps={{
                                    fill: 'transparent',
                                    strokeWidth: '0.3',
                                    stroke: arrow.color,
                                }}
                                tailSize={2}
                                strokeWidth={5}
                                headSize={2}
                                color={arrow.color}
                                start={`question-${arrow.start}`}
                                end={`answer-${arrow.end}`}
                            />
                        );
                    })}
                </div>
            </div>
            <div className="nextQuestionButton">
                <Button
                    disabled={disabledButton}
                    type={'checkButton'}
                    text={'check'}
                    action={checkAnswer}
                />
            </div>
        </div>
    );
}
